'use client'

import { AuthDialogModal } from '@/components/AuthDialogModal'
import { getAuthRedirectUrl } from '@/utils/auth-redirect'

interface SignInModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  redirectTo?: string
  description?: string
  defaultPath?: 'sign-in' | 'sign-up'
}

export function SignInModal({
  open,
  onOpenChange,
  redirectTo,
  description = "Welcome back!",
  defaultPath = "sign-in"
}: SignInModalProps) {
  // Construct the auth-redirect URL with the original redirectTo as a query parameter
  const finalRedirectTo = getAuthRedirectUrl(redirectTo);
  return (
    <AuthDialogModal
      open={open}
      onOpenChange={onOpenChange}
      title={description}
      authPath={defaultPath}
      redirectTo={finalRedirectTo}
    />
  )
}

